// extracted by mini-css-extract-plugin
module.exports = {"main-template":"MainTemplate-0e2e2c37bb109b915304b9e8edd779a4","mainTemplate":"MainTemplate-0e2e2c37bb109b915304b9e8edd779a4"};